<div class="modal-header" id="error-log-modal-title">
    <h3 class="modal-title" translate="VIEW_LOGS_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <div class="mb-3">
        <textarea
            class="form-control textAreaErrorLog"
            #textAreaErrorLog
            [attr.aria-label]="'ERROR_LOG_HEADER_TITLE' | translate"
        >
            {{ logEntriesString }}
        </textarea>
    </div>
</div>
<div class="modal-footer">
    <button
        class="btn btn-primary"
        type="button"
        [ngxClipboard]="textAreaErrorLog"
        (cbOnSuccess)="onClipboardCopySuccess($event)"
        [disabled]="isCopied"
    >
        {{ clipboardCopyButtonLabel }}
    </button>
</div>
